import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const useSearchParams = <
  SearchParamsType extends Record<string, unknown>,
>() => {
  const { pathname, search } = useLocation();
  const { replace } = useHistory();

  type ProcessedSearchParamsType = Partial<{
    [K in keyof SearchParamsType]: string;
  }>;

  const searchParams = useMemo(
    () =>
      Object.fromEntries(
        new URLSearchParams(search),
      ) as ProcessedSearchParamsType,
    [search],
  );

  const setSearchParams = useCallback(
    (params: Partial<SearchParamsType>) => {
      const urlSearchParams = new URLSearchParams();
      Object.entries(params).forEach(([param, value]) => {
        if (value !== undefined) {
          urlSearchParams.set(param, value);
        }
      });

      replace({ pathname, search: urlSearchParams.toString() });
    },
    [pathname, replace],
  );

  return [searchParams, setSearchParams] as const;
};
